import {swiperAllSliders} from "./swiperAllSliders.js";

export const swiperSlideChange = (tabsList, tabsWrap) => {
    tabsList.on('slideChange', () => swiperAllSliders(tabsList, tabsWrap, tabsList.realIndex));
    tabsWrap.on('slideChange', () => swiperAllSliders(tabsList, tabsWrap, tabsWrap.realIndex));
}